import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import type { FormLabelType } from "src/shared/forms/formrenderers/FormLabelRenderer";
import {
  type ITextInputProps,
  TextInput,
} from "src/shared/forms/inputs/TextInputNew";
import { combineValidations } from "src/shared/forms/validations/combineValidations";

export interface IPhoneNoInputProps
  extends Omit<
    ITextInputProps,
    "regex" | "type" | "isNoTrailingSpace" | "label"
  > {
  label?: FormLabelType;
  isNorthAmericanPhoneOnly?: boolean;
  phoneRegex?: RegExp;
}

export const PhoneNoInput = ({
  isNorthAmericanPhoneOnly,
  phoneRegex,
  ...rest
}: IPhoneNoInputProps) => {
  const validations = useMemo(() => {
    return combineValidations(
      (value) => {
        return value && !(phoneRegex ?? /^1([0-9]+)$/i).test(value) ? (
          <FormattedMessage id="form.validations.phone_no.invalid" />
        ) : undefined;
      },
      isNorthAmericanPhoneOnly &&
        ((value) => {
          return value && value.length !== 11 ? (
            <FormattedMessage id="form.validations.phone_no.invalid" />
          ) : undefined;
        }),
    );
  }, [isNorthAmericanPhoneOnly, phoneRegex]);

  return (
    <TextInput
      label={<FormattedMessage id="form.phone_no" />}
      {...rest}
      validators={validations}
    />
  );
};
